// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 744 ? "actioncable" : chunkId) + "-" + {"344":"94a1db96867ff6d83198","481":"c70c8614599dcc79079a","605":"0250f5d373793a57caba","744":"8b387cb23a4d51b4a473"}[chunkId] + ".chunk.js";
};